import { ExcahngeRate } from './exchange-rate';

export interface Currency {
    code: string;
    name: string;
    type: CurrencyType;
    currentExchangeRate: ExcahngeRate;
    currentUsdExchangeRate: ExcahngeRate;
    allowedDecimals: number;
    imageUrl: string;
    colorCode: string;
    sortOrder: number;
    acceptedPairs: string[];
    allStablePairs?: string[];
    categories: CryptocurrencyCategory[];
}

export interface CryptocurrencyCategory {
  id: number;
  name: String;
}

export interface  CurrencyNetwork {
    name: string;
    code: string;
}

export enum CurrencyType {
    Fiat = 'Fiat',
    Crypto = 'Crypto'
}
